var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGermanyFlag = function SvgGermanyFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#germany-flag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.622 13.478a10.004 10.004 0 0 0 18.756 0L10 12.608l-9.378.87Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C5.7 0 2.035 2.714.622 6.522l9.378.87 9.378-.87A10.004 10.004 0 0 0 10 0Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.622 6.522A9.979 9.979 0 0 0 0 10c0 1.223.22 2.395.622 3.478h18.756A9.977 9.977 0 0 0 20 10c0-1.223-.22-2.395-.622-3.478H.622Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "germany-flag_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgGermanyFlag;